<template>
  <button
    ref="elRef"
    type="button"
    class="btn"
    :class="{
      'btn--responsive': props.responsive,
      'btn--sm': props.size === 'sm',
      'btn--light': props.variation === 'light',
      'btn--white': props.variation === 'white',
      'btn--inverse': props.variation === 'inverse',
      'btn--link': props.variation === 'link',
      'btn--link-accent': props.variation === 'link-accent',
      'btn--loading': props.loading,
    }"
    :disabled="props.disabled || props.loading"
  >
    <AppLoader v-if="props.loading" :variation="loaderVariation" />
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
import { computed, ref } from "vue";
import AppLoader from "@/components/app-loader.vue";

const props = defineProps<{
  responsive?: boolean;
  size?: "sm";
  variation?: "light" | "white" | "inverse" | "link" | "link-accent";
  loading?: boolean;
  disabled?: boolean;
}>();

const elRef = ref<HTMLButtonElement>();

const loaderVariation = computed(() => {
  if (!props.variation) {
    return "white";
  }

  return "accent";
});

const focus = () => elRef.value?.focus();

defineExpose({
  focus,
});
</script>
